<div
  class="relative flex flex-col w-full h-full p-2 sm:p-4 md:p-6 lg:p-8 xl:p-10 2xl:p-12 overflow-hidden bg-dashboard-bg">
  <div class="relative z-10 mb-4 sm:mb-6 md:mb-8 lg:mb-10 xl:mb-12 2xl:mb-14">
    <h2
      class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-white tracking-widest uppercase font-tech">
      Closed Knitting Orders
    </h2>
  </div>

  @if (orders().length === 0) {
  <div
    class="relative z-10 flex-1 flex items-center justify-center text-white/40 font-tech tracking-widest text-base sm:text-lg uppercase">
    Sin órdenes cerradas
  </div>
  } @else {
  <div class="relative z-10 flex-1 flex flex-col gap-2 sm:gap-4 md:gap-6 overflow-hidden min-h-0"
    [@staggerSlideIn]="animationTrigger()">
    @for (order of orders(); track order.knittingOrderNumber; let i = $index) {
    <div class="flex flex-col gap-1 sm:gap-2">
      <div class="flex items-center gap-4 sm:gap-6 md:gap-8 lg:gap-12">
        <span
          class="text-white font-black text-sm sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl tracking-tight w-[15%] sm:w-[20%]">
          {{ order.knittingOrderNumber }}
        </span>

        <div
          class="flex-1 h-4 sm:h-6 md:h-10 lg:h-12 xl:h-14 2xl:h-16 bg-dashboard-panel rounded-md sm:rounded-lg md:rounded-xl lg:rounded-2xl overflow-hidden p-1 sm:p-2 relative">
          <div class="h-full bg-dashboard-bg rounded-sm sm:rounded-md md:rounded-lg lg:rounded-xl progress-bar-fill"
            appAnimateProgressBar [progressValue]="order.progress" [animationDelay]="500 + i * 100"></div>
          <span
            class="absolute inset-0 flex items-center justify-center text-dashboard-panel font-black text-[8px] sm:text-[10px] md:text-sm lg:text-base xl:text-lg 2xl:text-xl tracking-tight uppercase">
            Closed
          </span>
        </div>

        <span
          class="text-white font-black text-sm sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl tracking-tight text-right w-[10%] sm:w-[15%]">
          {{ order.progress }}%
        </span>
      </div>

      <div class="flex items-center gap-4 sm:gap-6 md:gap-8 lg:gap-12">
        <div class="w-[15%] sm:w-[20%]"></div>
        <div
          class="flex-1 flex justify-between px-1 font-bold text-[8px] sm:text-[10px] md:text-sm lg:text-lg xl:text-xl 2xl:text-2xl tracking-tight">
          <span class="text-white/70">{{ order.currentLbs }} LBS</span>
          <span class="text-white">{{ order.totalLbs }} LBS</span>
        </div>
        <div class="w-[10%] sm:w-[15%]"></div>
      </div>
    </div>
    }
  </div>
  }
</div>
